import { Amplitude } from '@amplitude/react-amplitude';
import { css } from '@emotion/react';
import classnames from 'classnames';
import get from 'lodash.get';
import map from 'lodash.map';
import size from 'lodash.size';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { LogEvent } from '@/modules/core/amplitude/types/Amplitude';
import { Asset } from '@/modules/core/data/types/Asset';
import { StudentSolutionDocument } from '@/modules/core/data/types/StudentSolutionDocument';
import { GenericObject } from '@/modules/core/data/types/GenericObject';
import {
  AMPLITUDE_ACTIONS,
  AMPLITUDE_EXTERNAL_LINK_TYPES,
} from '@/modules/core/amplitude/events';
import DocumentButton from '@/components/dataDisplay/DocumentButton';
import ExternalLink from '@/components/dataDisplay/ExternalLink';

type Props = {
  documents: Asset[];
  className?: string;
}

const SolutionDocuments: React.FunctionComponent<Props> = (props) => {
  const {
    documents, className,
  } = props;
  const { t } = useTranslation();

  return (
    <Amplitude
      eventProperties={(inheritedProps): GenericObject => ({
        ...inheritedProps,
      })}
    >
      {({ logEvent }: { logEvent: LogEvent }): JSX.Element => (
        <div
          className={classnames(className)}
          css={css`
            margin-top: 10px;

            .documents-list {
              list-style-type: none;
              padding: 0;
              margin: 0;
            }
          `}
        >
          {
            size(documents) ? (
              <Fragment>
                <h3>
                  {t('solutionsPage.solutionCard.documents.label', 'Documents supplémentaires')}
                </h3>
                <ul className={'documents-list'}>
                  {
                    map(documents, (document: StudentSolutionDocument, i: number) => {
                      const key = document?.id || i;
                      const linkUrl = document?.assetUrl;

                      return (
                        <li
                          key={key}
                        >
                          <ExternalLink
                            href={linkUrl}
                            onClick={(): void => {
                              logEvent('solutions-externalLink-opened', {
                                selection: {
                                  url: linkUrl,
                                  type: AMPLITUDE_EXTERNAL_LINK_TYPES.DOCUMENT,
                                },
                                action: AMPLITUDE_ACTIONS.CLICK,
                              });
                            }}
                          >
                            <DocumentButton>
                              {get(document, 'title', t('solutionsPage.solutionCard.additionalDocument.fallbackLink', 'Voir document'))}
                            </DocumentButton>
                          </ExternalLink>
                        </li>
                      );
                    })
                  }
                </ul>
              </Fragment>
            ) : null
          }
        </div>
      )}
    </Amplitude>
  );
};

export default SolutionDocuments;
